import Button from '@ingka/button';
import InlineMessage from '@ingka/inline-message';
import SSRIcon from '@ingka/ssr-icon';
import blockOutPath from '@ingka/ssr-icon/paths/block-out';
import Text from '@ingka/text';
import '@ingka/inline-message/dist/style.css';
import AppFooter from '@/components/layout/AppFooter';
import AppHeader from '@/components/layout/AppHeader';
import { useApp } from '@/context/AppContext';
import styles from './WaitingForAccessPage.module.css';

const COPY = {
  title: 'Welcome. You do not have permission to upload files yet.',
  messageTitle: 'To request upload permission',
  messageBody:
    'Please contact someone in the CMPMaster team. Once upload permission has been granted, sign out and sign back in to CMPMaster to start uploading files.',
};

export default function WaitingForAccessPage() {
  const { user, handleSignout } = useApp();

  return (
    <div className={styles.shell}>
      <AppHeader />
      <main className={styles.main}>
        <div className={styles.card}>
          <div className={styles.iconWrap}>
            <SSRIcon paths={blockOutPath} />
          </div>

          <Text tagName="h1" textStyle="Heading.L" className={styles.title}>
            {COPY.title}
          </Text>

          <div className={styles.message}>
            <InlineMessage variant="cautionary" title={COPY.messageTitle} body={COPY.messageBody} />
          </div>

          <Text tagName="p" textStyle="Body.S" className={styles.signedInAs}>
            Signed in as: <strong>{user?.email}</strong>
          </Text>

          <Button type="secondary" text="Sign out" onClick={handleSignout} />
        </div>
      </main>
      <AppFooter />
    </div>
  );
}
